import i18next from "i18next"
import { initReactI18next } from "react-i18next"
import LanguageDetector from "i18next-browser-languagedetector"
import en from "./translation/en/translation.json"
import ru from "./translation/ru/translation.json"

const resources = {
  en: {
    translation: en
  },
  ru: {
    translation: ru
  }
}

i18next
  .use(initReactI18next)
  .use(LanguageDetector)
  .init({
    fallbackLng: "en",
    //lng: "en",
    resources,
    interpolation: {
      escapeValue: false
    }
  })

export default i18next
